import { PageHeader } from 'antd'
import { useTranslation } from 'react-i18next'

const WashingHistoryHeader = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageHeader
        style={{ padding: 0 }}
        ghost={false}
        title={t('components.pages.washingHistory.listReport.pageHeader.title')}
      />
    </>
  )
}

WashingHistoryHeader.displayName = 'WashingHistoryHeader'
export default WashingHistoryHeader
